import { FilterCollapse } from 'libs/searchspring/components/collection/filters/FilterCollapse'
import { FilterInputSlider } from 'libs/searchspring/components/collection/filters/FilterSlider'
import { useFetchedFilter, useFilterCustomizations, useFilterValues, useActiveFilterLabel } from 'libs/searchspring/components/collection/filters/FilterHooks'

export function FilterItem({ filter, activeFilters, fetchedFilters, onFilter }) {
  if (!filter) return null

  const fetchedFilter = useFetchedFilter(filter, fetchedFilters)
  const filterCustomizations = useFilterCustomizations(filter.field)
  const values = useFilterValues(filter, activeFilters, fetchedFilter, filterCustomizations)
  const activeFilterLabel = useActiveFilterLabel(filter, values, fetchedFilter)

  // Render appropriate filter content based on type
  const FilterContent = () => {
    switch (filter.type) {
      case 'slider':
        return <FilterInputSlider filter={filter} fetchedFilter={fetchedFilter} onFilter={onFilter} />
      case 'list':
        if (!values.length) return null
        return <FilterInputs field={filter.field} values={values} onFilter={onFilter} />
      default:
        if (!values.length) return null
        return <FilterInputs field={filter.field} values={values} onFilter={onFilter} />
    }
  }

  return (
    <FilterCollapse label={filter.label} activeFilterLabel={activeFilterLabel}>
      <div className="flex flex-col gap-y-1.5 lg-max:px-margin pt-0.75 pb-1.875">
        {FilterContent()}
      </div>
    </FilterCollapse>
  )
}

const FilterInputs = ({ values, onFilter, field }) => {
  return (
    <>
    {values.map((item) => {
      return (
        <div className="flex items-center gap-x-0.5 cursor-pointer" key={item.value}>
          <input
            id={item.value}
            className="field-checkbox peer disabled:opacity-50 disabled:pointer-events-none disabled:cursor-not-allowed"
            type="checkbox"
            name={field}
            checked={item.checked}
            disabled={item.disabled}
            onClick={() => onFilter(item.value)}
            aria-label={item.label}
          />
          <label
            for={item.value}
            className="flex items-center text-s whitespace-nowrap cursor-pointer peer-disabled:opacity-50 peer-disabled:pointer-events-none peer-disabled:cursor-not-allowed"
          >
            {item.label}
            <span className="text-neutral-secondary">
              &nbsp;({item.count ?? 0})
            </span>
          </label>
        </div>
      )
    })}
    </>
  )
}
